var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-delegate"},[(_vm.isLoading)?_c('LoadingSmallSpinner'):_vm._e(),(_vm.contentType === 'video')?_c('Video',_vm._b({ref:"currentVideo",on:{"update-status":_vm.handleVideoStatusUpdate,"is-loading":_vm.emitLoadingState,"is-course-active":_vm.updateIsCourseActive,"advance-media":function($event){return _vm.$emit('advance-media')}}},'Video',{
      content: _vm.content,
      nextMedia: _vm.nextMedia,
      userCompletionStatus: _vm.userCompletionStatus,
      parentType: _vm.parentType,
      parent: _vm.parent,
      parentData: _vm.parentData,
    },false)):_vm._e(),(_vm.isOfIFrameType)?_c('IFrame',_vm._b({on:{"is-course-active":_vm.updateIsCourseActive,"is-loading":_vm.emitLoadingState}},'IFrame',{
      content: _vm.content,
      parentType: _vm.parentType,
      parent: _vm.parent,
      userCompletionStatus: _vm.userCompletionStatus,
    },false)):_vm._e(),(_vm.contentType === 'quiz')?_c('Quiz',_vm._b({on:{"is-loading":_vm.emitLoadingState,"heartbeat":_vm.handleQuizHeartbeats,"toggle-quiz":function($event){return _vm.$emit('toggle-quiz')}}},'Quiz',{
      content: _vm.content,
      userCompletionStatus: _vm.userCompletionStatus,
      contentTitle: _vm.contentTitle,
      nextMedia: _vm.nextMedia,
      canStartIssue: _vm.canStartIssue,
      parent: _vm.parent,
      parentType: _vm.parentType,
    },false)):_vm._e(),(_vm.contentType === 'exercise')?_c('ExercisesList',_vm._b({},'ExercisesList',{
      exercises: _vm.content.media,
      isUser: _vm.hasAccess,
      parentType: _vm.parentType,
    },false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }